<ng-container>
  <div
    *ngIf="loading !== true"
    (click)="onChange()"
    [class.mobile]="mobileMode"
    class="popsy-checkbox flex"
    [cdkTrapFocus]="focus">
    <div class="box" [class.checked]="isChecked">
      <div *ngIf="isChecked" class="circle"></div>
    </div>
    <span *ngIf="text" class="label" [class.bold]="boldLabel">{{ text }}</span>
    <ng-container *ngIf="optionText">
      <span class="dynamic-space" aria-hidden="true"></span>
      <span class="option-text bold text-highlight">{{ optionText }}</span>
    </ng-container>
  </div>

  <!-- Placeholder -->
  <div class="skeleton popsy-checkbox" *ngIf="loading === true" aria-hidden="true">
    <popsy-skeleton class="skeleton box"></popsy-skeleton>
    <span class="fixed-space-8" aria-hidden="true"></span>
    <popsy-skeleton class="skeleton label"></popsy-skeleton>
  </div>
</ng-container>
